import adyenService from './rbata.payment-page-adyen';

const paymentPage = {
    showNoPaymentSelectedError: $('#noPaymentSelectedError'),

    submitPaymentDetails() {
        this.disableSubmitButton();
        this.noPaymentError();

        if (adyenService.noPayment) {
            adyenService.placeOrder(undefined);
        } else {
            if (adyenService.paymentSelected) {
                adyenService.submitPayment();
            } else {
                this.enableSubmitButton();
            }
        }
    },

    noPaymentError() {
        adyenService.paymentSelected || adyenService.noPayment
                ? this.showNoPaymentSelectedError.addClass('d-none')
                : this.showNoPaymentSelectedError.removeClass('d-none')
    },

    disableSubmitButton() {
        $('#submitPayment').attr("disabled", "disabled");
    },
    enableSubmitButton() {
        $('#submitPayment').removeAttr("disabled");
    },

    bindHandlers() {
        $('#submitPayment').on('click', (evt) => {
            this.submitPaymentDetails();
        });
    }
};

$(() => {
    if ($('#payment-page').length) {
        paymentPage.bindHandlers();
    }
});

export default paymentPage
